import { Component, EventEmitter, Input, Output } from '@angular/core';
import { format as formatDate } from 'date-fns';

export class TimePickerTime {
    hours: string | undefined = undefined;
    minutes: string | undefined = undefined;
    amPm: 'am' | 'pm' = 'am';

    constructor(initParams?: { hours: string | undefined; minutes: string | undefined; amPm: 'am' | 'pm' }) {
        if (initParams) {
            this.hours = initParams.hours;
            this.minutes = initParams.minutes;
            this.amPm = initParams.amPm;
        }
    }

    format(format = 'HH:mm:ss') {
        return formatDate(this.toDate(), format);
    }

    // Reproduce moment's lenient parsing of `${hours}:${minutes}:00 ${amPm}` with the
    // 'h:m:ss a' format. moment ignores the am/pm suffix for hours 0 and 13..23 and
    // applies 12-hour semantics only for hours 1..12 (12am->0, 12pm->12, 0pm->12).
    // Verified identical to moment across the full hour/min/am-pm input space.
    private toDate(): Date {
        let h = parseInt(this.hours as string, 10);
        let m = parseInt(this.minutes as string, 10);
        if (isNaN(h)) h = 0;
        if (isNaN(m)) m = 0;
        let hour24: number;
        if (h === 0) {
            hour24 = this.amPm === 'pm' ? 12 : 0;
        } else if (h >= 1 && h <= 12) {
            hour24 = this.amPm === 'pm' ? (h % 12) + 12 : h % 12;
        } else {
            hour24 = h % 24;
        }
        const d = new Date();
        d.setHours(hour24, m, 0, 0);
        return d;
    }

    toString(): string {
        return this.hours + ':' + this.minutes + ':00 ' + this.amPm;
    }

    isValid(): boolean {
        return this.hours !== undefined && this.minutes !== undefined;
    }
}

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent {
    @Input()
    set initialTime(value: TimePickerTime) {
        setTimeout(() => {
            if (!value) {
                return;
            }
            this.selectedHour = value.hours;
            this.selectedMinute = value.minutes;
            this.selectedAmPm = value.amPm;
        }, 500);
    }
    @Input() time;
    @Output() initialTimeChange = new EventEmitter<TimePickerTime>();
    @Output() changed = new EventEmitter<TimePickerTime>();
    hours: any = [];
    selectedHour;
    selectedMinute;
    minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
    selectedAmPm: 'am' | 'pm' = 'am';

    constructor() {}
    ngOnInit(): void {
        if (this.time == '24') {
            this.hours = [
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
            ];
        } else {
            this.hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        }
    }
    switchedAmPm($event) {
        this.selectedAmPm = $event.id;
        this.hoursMinutesChanged();
    }

    hoursMinutesChanged() {
        this.changed.emit(
            new TimePickerTime({ hours: this.selectedHour, minutes: this.selectedMinute, amPm: this.selectedAmPm })
        );
        this.initialTimeChange.emit(
            new TimePickerTime({ hours: this.selectedHour, minutes: this.selectedMinute, amPm: this.selectedAmPm })
        );
    }
}
